import { BaseModel } from "@blue-chip/core";
import Office from "./Office";

export default class Team extends BaseModel {
  static get belongsTo() {
    return [Office];
  }
}
